(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7646,2576,5124,949],{

/***/ 40610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/api/routes/customers/queries/index.ts + 4 modules
var queries = __webpack_require__(34157);
;// CONCATENATED MODULE: ../../libs/utils/verifyDataExists/verifyDataExists.ts
/**
 * Verify that the data object contains all the keys
 * @param data - The data object to verify
 * @param keys - The keys to verify
 * @returns A boolean indicating if the data object contains all the keys
 */
var verifyDataExists = function verifyDataExists(data, keys) {
  var result = true;

  for (var i = 0; i < keys.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(data, keys[i])) {
      if (false) {}

      result = false;
    }
  }

  return result;
};

/* harmony default export */ var verifyDataExists_verifyDataExists = (verifyDataExists);
// EXTERNAL MODULE: ../../libs/utils/useRichTextTableOfContent/index.ts + 1 modules
var useRichTextTableOfContent = __webpack_require__(43906);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var HeroSection = function HeroSection(_ref) {
  var title = _ref.title,
      featuredImage = _ref.featuredImage,
      heroCtaText = _ref.heroCtaText,
      heroCtaUrl = _ref.heroCtaUrl,
      useCase = _ref.useCase,
      industry = _ref.industry,
      location = _ref.location,
      region = _ref.region,
      products = _ref.products;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var overviewItems = (0,react.useMemo)(function () {
    return [{
      title: "Use Case",
      data: useCase
    }, {
      title: "Region",
      data: region
    }, {
      title: "Industry",
      data: industry
    }, {
      title: "Products",
      data: products
    }, {
      title: "Headquarters",
      data: location
    }];
  }, [useCase, industry, location, region, products]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            href: (0,getAbsoluteUrl/* default */.Z)("/customers/", pageConfig),
            tag: "a",
            size: "small",
            iconStart: Common/* ChevronLeftIcon */.wy,
            variant: "mono",
            children: "Customers"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
            tag: "h1",
            variant: "h1",
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
            columns: 1,
            overrides: {
              md: 2
            },
            children: overviewItems.map(function (item) {
              return item.data && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                  variant: "overline",
                  tag: "p",
                  children: item.title
                }), Array.isArray(item.data) ? item.data.map(function (item) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
                    variant: "pMedium",
                    children: item.fields.title
                  }, item.fields.title);
                }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
                  variant: "pMedium",
                  children: item.data
                })]
              }, item.title);
            })
          }), heroCtaText && heroCtaUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
            href: heroCtaUrl,
            color: "primary",
            variant: "filled",
            size: "large",
            children: heroCtaText
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroContents, {
        children: featuredImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImage, {
          role: "img",
          alt: "Featured image",
          title: "Featured image",
          background: featuredImage.fields.file.url
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ertk3ze12"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ertk3ze11"
} : 0)( true ? "" : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ertk3ze10"
} : 0)("margin:16px 0 8px;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[80];
}, ";" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ertk3ze9"
} : 0)( true ? {
  name: "15z0i6c",
  styles: "margin:0 0 4px"
} : 0);

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "ertk3ze8"
} : 0)(Hero/* Wrapper */.im, "{grid-template-columns:1fr;grid-template-areas:'copy' 'contents';justify-content:center;align-items:center;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xxl");
}, "{grid-template-columns:minmax(764px, 60%) minmax(356px, 35%);grid-template-areas:'copy contents';gap:80px;}}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "ertk3ze7"
} : 0)("max-width:unset;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xxl");
}, "{min-height:720px;}" + ( true ? "" : 0));

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "ertk3ze6"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "ertk3ze5"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.between("lg", "lg");
}, "{font-size:40px;line-height:48px;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "ertk3ze4"
} : 0)(function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.h5;
}, ";font-size:18px;line-height:24px;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("xxl");
}, "{margin-bottom:40px;}" + ( true ? "" : 0));

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "ertk3ze3"
} : 0)("display:grid;justify-items:left;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("xxl");
}, "{justify-items:right;}" + ( true ? "" : 0));

var HeroImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ertk3ze2"
} : 0)("background-image:url('", function (_ref10) {
  var background = _ref10.background;
  return background;
}, "');background-size:cover;background-position:center;display:inline-block;box-shadow:0px 75px 45px -65px rgba(0, 0, 0, 0.5);border-radius:10px;max-width:327px;width:100%;height:375px;", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.up("sm");
}, "{height:400px;}", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("md");
}, "{height:440px;}", function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.up("xxl");
}, "{max-width:100%;height:540px;}" + ( true ? "" : 0));

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Description,  true ? {
  target: "ertk3ze1"
} : 0)("color:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.twilio.gray[80];
}, ";" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "ertk3ze0"
} : 0)( true ? {
  name: "xy0k4",
  styles: "row-gap:16px"
} : 0);

/* harmony default export */ var Hero_Hero = (HeroSection);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Results/Results.tsx



var _renderNode;

function Results_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "Results",
  linkText: "Request demo"
};
var options = {
  renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.HEADING_4, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRichText, {
        tag: "h2",
        variant: "h4",
        children: children
      })]
    });
  }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRichText, {
      variant: "pMedium",
      children: children
    });
  }), _renderNode)
};

var Results = function Results(_ref) {
  var _file$details$image2, _file$details$image3;

  var data = _ref.data,
      demoUrl = _ref.demoUrl,
      logo = _ref.logo;
  var content = (0,react.useMemo)(function () {
    if (!data) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: data,
      options: options
    });
  }, [data]);
  var _logo$fields = logo.fields,
      file = _logo$fields.file,
      description = _logo$fields.description;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Results_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, {
      loader: function loader() {
        var _file$details$image;

        return (0,contentfulImageLoader/* default */.Z)({
          src: file.url,
          width: Number((_file$details$image = file.details.image) === null || _file$details$image === void 0 ? void 0 : _file$details$image.width)
        });
      },
      width: (_file$details$image2 = file.details.image) === null || _file$details$image2 === void 0 ? void 0 : _file$details$image2.width,
      height: (_file$details$image3 = file.details.image) === null || _file$details$image3 === void 0 ? void 0 : _file$details$image3.height,
      src: file.url,
      alt: description
    }), data && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "overline",
        children: copy.heading
      }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
        children: content
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
      tag: "a",
      size: "medium",
      href: demoUrl,
      iconEnd: Common/* ChevronRightIcon */.XC,
      children: copy.linkText
    })]
  });
};

/* harmony default export */ var Results_Results = (Results);

var Results_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "en2eddl5"
} : 0)("max-width:320px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{position:sticky;top:160px;left:0;}" + ( true ? "" : 0));

var StyledRichText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "en2eddl4"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "en2eddl3"
} : 0)("color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[80];
}, ";" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "en2eddl2"
} : 0)( true ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : 0);

var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "en2eddl1"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "en2eddl0"
} : 0)( true ? {
  name: "1ichgcs",
  styles: "max-height:28px;object-position:left bottom;object-fit:contain;margin-bottom:36px"
} : 0);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Form/Form.tsx


function Form_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Form_copy = {
  heading: "Interested in hearing more about how Segment can help you?",
  description: "Connect with the team to learn how 25,000+ companies use Segment's extensible, scalable platform to turn customer data into revenue-generating experiences.",
  buttonText: "Get a demo"
};

var Form = function Form() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h3",
        tag: "h2",
        children: Form_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "pLarge",
        children: Form_copy.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
          isProgressive: true,
          customFormIdentifier: "site-customers-detail-demo",
          successMessageAppearance: "twilioLight"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
};

/* harmony default export */ var Form_Form = (Form);

var Form_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fryehx2"
} : 0)( true ? "" : 0);

var Inner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fryehx1"
} : 0)( true ? {
  name: "vs5ck",
  styles: "padding:16px 0 35px"
} : 0);

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fryehx0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{width:50%;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/recipes/PropCard/index.ts + 6 modules
var PropCard = __webpack_require__(62456);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Content/PropCardCta.tsx


function PropCardCta_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var PropCardCta = function PropCardCta(_ref) {
  var _file$details$image, _file$details$image2;

  var heading = _ref.heading,
      paragraph = _ref.paragraph,
      buttonText = _ref.buttonText,
      buttonUrl = _ref.buttonUrl,
      image = _ref.image;
  var file = image.fields.file;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCardCta_Wrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Title */.Dx, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Text */.xv, {
            children: paragraph
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            size: "medium",
            tag: "a",
            href: buttonUrl,
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: buttonText
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Img */.Ei, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Picture, {
            src: file.url,
            alt: file.fileName,
            width: (_file$details$image = file.details.image) === null || _file$details$image === void 0 ? void 0 : _file$details$image.width,
            height: (_file$details$image2 = file.details.image) === null || _file$details$image2 === void 0 ? void 0 : _file$details$image2.height
          })
        })]
      })
    })
  });
};

var PropCardCta_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ahr5c0"
} : 0)( true ? {
  name: "1ab8s7t",
  styles: "margin:30px 0"
} : 0);

var Picture = function Picture(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("picture", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: width,
      height: height,
      src: src,
      alt: alt,
      loading: "lazy"
    })
  });
};

/* harmony default export */ var Content_PropCardCta = (PropCardCta);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Content/Content.tsx



function Content_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Content = function Content(_ref) {
  var data = _ref.data,
      tableOfContentState = _ref.tableOfContentState;
  var options = (0,react.useMemo)(function () {
    var _renderNode;

    return {
      renderMark: (0,defineProperty/* default */.Z)({}, dist.MARKS.BOLD, function (text) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bold, {
          children: text
        });
      }),
      renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypograpy, {
          variant: "pLarge",
          tag: "p",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.QUOTE, function (_, children) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote, {
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.EMBEDDED_ENTRY, function (node) {
        switch (node.data.target.sys.contentType.sys.id) {
          case "inlineCta":
            {
              var _node$data$target$fie = node.data.target.fields,
                  heading = _node$data$target$fie.heading,
                  paragraph = _node$data$target$fie.paragraph,
                  buttonText = _node$data$target$fie.buttonText,
                  buttonUrl = _node$data$target$fie.buttonUrl,
                  image = _node$data$target$fie.image;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content_PropCardCta, {
                heading: heading,
                paragraph: paragraph,
                buttonText: buttonText,
                buttonUrl: buttonUrl,
                image: image
              });
            }

          default:
            return null;
        }
      }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.HEADING_2, function (node, children) {
        var id = tableOfContentState.getId(node);
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "h2",
          tag: "h2",
          id: id,
          children: children
        });
      }), _renderNode)
    };
  }, [tableOfContentState]);
  var content = (0,react.useMemo)(function () {
    if (!data) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: data,
      options: options
    });
  }, [data, options]);
  var headingslist = data.content.filter(function (item) {
    return item.nodeType === "heading-2";
  }).map(function (item) {
    return item.content[0].value;
  });
  var slugsList = headingslist.map(function (item) {
    return item.toLocaleLowerCase().replace(/[^A-Za-z0-9 \s]/g, "").split(" ").join("-");
  });

  var Toc = function Toc() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TocWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h2",
        tag: "h2",
        children: "Table of Contents"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
        variant: "pLarge",
        tag: "div",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ol", {
          children: headingslist.map(function (heading, id) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: "#" + slugsList[id],
                onClick: function onClick(e) {
                  e.preventDefault();
                  (0,useScrollToAnchor/* scrollToAnchor */.d)(slugsList[id], -100);
                },
                children: heading
              })
            }, heading);
          })
        })
      })]
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content_Wrapper, {
    children: [headingslist.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toc, {}), content, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_Form, {})]
  });
};

/* harmony default export */ var Content_Content = (Content);

var Content_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "etyspqw5"
} : 0)( true ? {
  name: "p6gv28",
  styles: "display:flex;flex-direction:column;padding-bottom:60px"
} : 0);

var Blockquote = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("blockquote",  true ? {
  target: "etyspqw4"
} : 0)("padding-left:21px;border-left:", function (_ref2) {
  var theme = _ref2.theme;
  return "3px solid ".concat(theme.palette.twilio.gray[20]);
}, ";margin:24px 0px;p{color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[60];
}, ";margin:0;}" + ( true ? "" : 0));

var StyledTypograpy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "etyspqw3"
} : 0)( true ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : 0);

var TocWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etyspqw2"
} : 0)( true ? {
  name: "1fgdcyd",
  styles: "margin-bottom:24px"
} : 0);

var ListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "etyspqw1"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var Bold = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("b",  true ? {
  target: "etyspqw0"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/TheBigWin/TheBigWin.tsx








var TheBigWin_copy = {
  heading: "The big win"
};

var renderNode = (0,defineProperty/* default */.Z)({}, dist.BLOCKS.PARAGRAPH, function (_, children) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
    variant: "pLarge",
    children: children
  });
});

var TheBigWin = function TheBigWin(_ref) {
  var bigWin = _ref.bigWin;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheBigWin_Heading, {
      tag: "h2",
      variant: "h2",
      children: TheBigWin_copy.heading
    }), bigWin && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
        data: bigWin,
        options: {
          renderNode: renderNode
        }
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
};

var Section = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "esuqcc43"
} : 0)( true ? "" : 0);

var Row = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esuqcc42"
} : 0)( true ? "" : 0);

var TheBigWin_Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "esuqcc41"
} : 0)("margin:0;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "esuqcc40"
} : 0)("margin-top:8px;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var TheBigWin_TheBigWin = (TheBigWin);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ./src/views/Customers/SinglePage/components/Video/assets/Cover@2x.png
var Cover_2x = __webpack_require__(50808);
var Cover_2x_default = /*#__PURE__*/__webpack_require__.n(Cover_2x);
// EXTERNAL MODULE: ./src/views/Customers/SinglePage/components/Video/assets/Cover.webp
var Cover = __webpack_require__(2130);
var Cover_default = /*#__PURE__*/__webpack_require__.n(Cover);
// EXTERNAL MODULE: ./src/views/Customers/SinglePage/components/Video/assets/Cover@2x.webp
var assets_Cover_2x = __webpack_require__(69544);
var assets_Cover_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Cover_2x);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Video/CoverImage.tsx








var CoverImage = function CoverImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((Cover_default()), ", ").concat((assets_Cover_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (Cover_2x_default()),
        alt: ""
      })]
    })
  });
};

/* harmony default export */ var Video_CoverImage = (CoverImage);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/Video/Video.tsx







var Video = function Video(_ref) {
  var url = _ref.url;

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        ariaLabel: "Play Button",
        onClick: play
      }), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_CoverImage, {}, "cover")]
    })
  });
};

/* harmony default export */ var Video_Video = (Video);

var Video_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jrgo4n0"
} : 0)("margin-bottom:30px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:60px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CustomerCard/index.ts + 2 modules
var CustomerCard = __webpack_require__(49976);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/components/MoreCustomers/MoreCustomers.tsx


function MoreCustomers_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var MoreCustomers = function MoreCustomers(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreCustomers_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreCustomers_StyledColumnTrack, {
      overrides: {
        sm: 2
      },
      children: entries.map(function (entry) {
        var _entry$fields$matchaL, _entry$fields$matchaL2, _entry$fields, _entry$fields$feature;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
          slug: entry.fields.slug,
          logo: (_entry$fields$matchaL = entry.fields.matchaLogo) === null || _entry$fields$matchaL === void 0 ? void 0 : (_entry$fields$matchaL2 = _entry$fields$matchaL.fields) === null || _entry$fields$matchaL2 === void 0 ? void 0 : _entry$fields$matchaL2.logoMono,
          img: entry === null || entry === void 0 ? void 0 : (_entry$fields = entry.fields) === null || _entry$fields === void 0 ? void 0 : (_entry$fields$feature = _entry$fields.featuredImage) === null || _entry$fields$feature === void 0 ? void 0 : _entry$fields$feature.fields.file.url,
          logoAltText: "".concat(entry.fields.slug, "'s company logo")
        }, entry.sys.id);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: (0,getAbsoluteUrl/* default */.Z)("/customers", pageConfig),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        tag: "span",
        children: "View all customers"
      })
    })]
  });
};

/* harmony default export */ var MoreCustomers_MoreCustomers = (MoreCustomers);

var Card = function Card(_ref2) {
  var _logo$fields$file$det2, _logo$fields$file$det3;

  var slug = _ref2.slug,
      img = _ref2.img,
      logo = _ref2.logo,
      logoAltText = _ref2.logoAltText;
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setIsHover = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: (0,getAbsoluteUrl/* default */.Z)("/customers/".concat(slug, "/"), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomerCard/* default */.Z, {
      tag: "span",
      img: img,
      hoverable: true,
      onMouseEnter: function onMouseEnter() {
        return setIsHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHover(false);
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerCard/* Row */.X, {
        children: logo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreCustomers_Logo, {
          loader: function loader() {
            var _logo$fields$file$det;

            return (0,contentfulImageLoader/* default */.Z)({
              src: logo.fields.file.url,
              width: Number((_logo$fields$file$det = logo.fields.file.details.image) === null || _logo$fields$file$det === void 0 ? void 0 : _logo$fields$file$det.width)
            });
          },
          width: (_logo$fields$file$det2 = logo.fields.file.details.image) === null || _logo$fields$file$det2 === void 0 ? void 0 : _logo$fields$file$det2.width,
          height: (_logo$fields$file$det3 = logo.fields.file.details.image) === null || _logo$fields$file$det3 === void 0 ? void 0 : _logo$fields$file$det3.height,
          src: logo.fields.file.url,
          alt: logoAltText || ""
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerCard/* Row */.X, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          variant: "mono",
          appearance: "dark",
          hover: isHover,
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Read their story"
        })
      })]
    })
  }, slug);
};

var MoreCustomers_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1yn5tby2"
} : 0)( true ? {
  name: "6eyjkl",
  styles: "display:grid;grid-template-columns:1fr;justify-items:center;gap:40px;max-width:1280px;margin:0 auto;padding:80px 24px"
} : 0);

var MoreCustomers_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1yn5tby1"
} : 0)("gap:16px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{gap:32px;}" + ( true ? "" : 0));

var MoreCustomers_Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1yn5tby0"
} : 0)( true ? {
  name: "8ftmze",
  styles: "max-height:24px;width:auto"
} : 0);
;// CONCATENATED MODULE: ./src/views/Customers/SinglePage/CustomerStory.tsx


function CustomerStory_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var CustomerStoryView = function CustomerStoryView(_ref) {
  var _data$fields$socialIm, _data$fields$socialIm2, _data$fields$socialIm3, _data$fields$matchaLo;

  var storySlug = _ref.storySlug,
      random = _ref.random,
      amount = _ref.amount;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useStoryQuery = (0,queries/* useStoryQuery */.c5)({
    args: [storySlug]
  }),
      data = _useStoryQuery.data;

  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useMoreCustomersQuer = (0,queries/* useMoreCustomersQuery */.Rw)({
    args: [{
      slug: storySlug,
      random: random,
      amount: amount
    }]
  }),
      moreCustomers = _useMoreCustomersQuer.data;

  if (!data) throw new Error("Story data is missing. Make sure it's preloaded");
  if (!verifyDataExists_verifyDataExists(data.fields, ["socialTitle", "title", "matchaLogo", "location", "content"])) throw new Error("Required fields are missing. Check log for details.");
  var tableOfContentState = (0,useRichTextTableOfContent/* default */.Z)(data.fields.content);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: data.fields.socialTitle,
      pageDescription: data.fields.socialDescription,
      themeColor: theme.palette.brand.darkAcai[700],
      bodyBackground: theme.palette.neutrals.white[100],
      pageOG: (_data$fields$socialIm = data.fields.socialImage) === null || _data$fields$socialIm === void 0 ? void 0 : (_data$fields$socialIm2 = _data$fields$socialIm.fields) === null || _data$fields$socialIm2 === void 0 ? void 0 : (_data$fields$socialIm3 = _data$fields$socialIm2.file) === null || _data$fields$socialIm3 === void 0 ? void 0 : _data$fields$socialIm3.url,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        title: data.fields.title,
        featuredImage: data.fields.featuredImage,
        heroCtaText: data.fields.heroCtaText,
        heroCtaUrl: data.fields.heroCtaUrl,
        useCase: data.fields.categoryUseCase,
        industry: data.fields.categoryIndustry,
        location: data.fields.location,
        region: data.fields.categoryRegion,
        products: data.fields.categoryProducts
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomerStory_Wrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sidebar, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_Results, {
              data: data.fields.results,
              demoUrl: (0,getAbsoluteUrl/* default */.Z)("/demo/?utm_medium=referral&utm_source=customer-story&utm_campaign=all_pmm_customer-story_&utm_content=demo-request", pageConfig),
              logo: (_data$fields$matchaLo = data.fields.matchaLogo) === null || _data$fields$matchaLo === void 0 ? void 0 : _data$fields$matchaLo.fields.logoColor
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomerStory_ContentWrapper, {
            children: [data.fields.videoUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Video, {
              url: data.fields.videoUrl
            }), data.fields.bigWin && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheBigWin_TheBigWin, {
              bigWin: data.fields.bigWin
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content_Content, {
              data: data.fields.content,
              tableOfContentState: tableOfContentState
            })]
          })]
        }), Boolean(moreCustomers === null || moreCustomers === void 0 ? void 0 : moreCustomers.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreCustomers_MoreCustomers, {
          entries: moreCustomers
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var CustomerStory_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15hjfwx3"
} : 0)("display:grid;max-width:1280px;padding:0 24px;margin:44px auto;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{margin:82px auto;grid-template-columns:2fr 8fr;gap:60px;justify-content:space-between;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xxl");
}, "{gap:200px;}" + ( true ? "" : 0));

var Sidebar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("aside",  true ? {
  target: "e15hjfwx2"
} : 0)("display:grid;gap:48px;margin-bottom:24px;grid-template-rows:auto 1fr;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:210px;}" + ( true ? "" : 0));

var CustomerStory_ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15hjfwx1"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e15hjfwx0"
} : 0)( true ? "" : 0);

/* harmony default export */ var SinglePage_CustomerStory = (CustomerStoryView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/customers/[slug].tsx





var CustomerStory = function CustomerStory(_ref) {
  var storySlug = _ref.storySlug,
      random = _ref.random,
      amount = _ref.amount;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SinglePage_CustomerStory, {
      storySlug: storySlug,
      random: random,
      amount: amount
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (CustomerStory);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 43906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useRichTextTableOfContent_useRichTextTableOfContent; },
  "q": function() { return /* reexport */ getNodeText; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/utils/useRichTextTableOfContent/useRichTextTableOfContent.tsx


var getNodeText = function getNodeText(element) {
  return element.content.map(function (innerNode) {
    return innerNode.nodeType === "text" ? innerNode.value : "";
  }).join();
};

var createState = function createState(data, _ref) {
  var nodeTypesHierarchy = _ref.nodeTypesHierarchy;
  var usedIds = new Set();
  var stateArray = nodeTypesHierarchy.map(function (nodeType) {
    var state = new Map();
    data === null || data === void 0 ? void 0 : data.content.forEach(function (element) {
      if (nodeType === element.nodeType) {
        var text = getNodeText(element);
        var slugBase = text.toLocaleLowerCase().replace(/[^A-Za-z0-9 \s]/g, "").split(" ").join("-");

        if (slugBase.match(/^\d/)) {
          slugBase = slugBase.replace(/^[0-9]+/, "");
          slugBase = slugBase.startsWith("-") ? slugBase.replace("-", "") : slugBase;
        }

        var slug = slugBase;
        var i = 1;

        while (usedIds.has(slug)) {
          slug = "".concat(slugBase, "-").concat(i++);
        }

        usedIds.add(slug);
        state.set(element, slug);
      }
    });
    return state;
  });
  return stateArray;
};

var defaultNodeTypesHierarchy = [dist.BLOCKS.HEADING_2];
/**
 * A hook that creates a table of content state from a rich text document.
 * @param data The rich text document to create the table of content state from.
 * @param options The options to use when creating the table of content state.
 * @returns The table of content state.
 */

var useRichTextTableOfContent = function useRichTextTableOfContent(data) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$nodeTypesHierar = _ref2.nodeTypesHierarchy,
      nodeTypesHierarchy = _ref2$nodeTypesHierar === void 0 ? defaultNodeTypesHierarchy : _ref2$nodeTypesHierar;

  var _useState = (0,react.useState)(function () {
    return createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    });
  }),
      state = _useState[0],
      setState = _useState[1];

  (0,react.useEffect)(function () {
    setState(createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    }));
  }, [data, nodeTypesHierarchy]);
  return (0,react.useMemo)(function () {
    return {
      getId: function getId(node) {
        var _state$find;

        return (_state$find = state.find(function (levelState) {
          return levelState.get(node);
        })) === null || _state$find === void 0 ? void 0 : _state$find.get(node);
      },
      getMenuLevelItems: function getMenuLevelItems(level) {
        return Array.from(state[level].entries());
      }
    };
  }, [state]);
};

/* harmony default export */ var useRichTextTableOfContent_useRichTextTableOfContent = (useRichTextTableOfContent);
;// CONCATENATED MODULE: ../../libs/utils/useRichTextTableOfContent/index.ts


/***/ }),

/***/ 26318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/[slug]",
      function () {
        return __webpack_require__(40610);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50808:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-931739b8e1dd0e0ee9c7e45a96bcfc84.png";

/***/ }),

/***/ 2130:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover-7d4a0001cf8ffa734481da5a78b4a876.webp";

/***/ }),

/***/ 69544:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-15f1634014ef0d3219644634aface972.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,6234,4136,2073,6784,5735,2429,2609,948,8187,3996,7947,7960,6012,442,6818,2472,3970,1770,9774,2888,179], function() { return __webpack_exec__(26318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);